export const MESSAGE = {
	PANEL:
		'You have exceeded the number of logs and traces based panels using query builder that are allowed in the community edition.',
	ALERT:
		'You have exceeded the number of alerts that are allowed in the community edition.',
	WIDGET: 'You have reached limit of {{widget}} free widgets.',
	CREATE_DASHBOARD:
		'You have reached limit of creating the query builder based dashboard panels.',
};
